//import liraries
import React, { Component, useState, useEffect } from "react";
import {  View,Text,FlatList,Image,ScrollView,TextInput,TouchableOpacity,Dimensions,
} from "react-native";
import QuickLinks from "./QuickLinks";
import { get, isEmpty } from "lodash";
import { getAllVehiclesList, filterVehicle } from "./../../api/apiManager";
import * as RootNavigation from "../../utilities/RootNavigation";
import Loader from "../../common/Loader";
import { Outlet } from "react-router-dom";
import useStyles from "./MyVehicles_Styles";
import Marquee from "react-fast-marquee";

// create a component
const isSmallDevice = Dimensions.get("window").width < 767;
const isTabView = Dimensions.get("window").width > 767 && Dimensions.get("window").width < 1024;

const MyVehicles = (props) => {

  const rechargeNotAllowed = global?.recharge_not_allowed || []

  const [loading, setLoading] = useState(false);
  const styles = useStyles();
  const [vehicleList, setVehicleList] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [selectLayout, setSelectedLayout] = useState("myVehicles");
  const [selectedVrn, setSelectedVrn] = useState("");
  const [selectedTagId, setSelectedTagId] = useState("");

  useEffect(() => {
    getVehicleList();
    setSelectedLayout('myVehicles')
  }, []);

  const getVehicleList = () => {
    setLoading(true);
    getAllVehiclesList()
      .then((res) => {
        if (res && !isEmpty(res)) {
          setVehicleList(res);
          setLoading(false)
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log("<------------ error in tag details ----------->");
      });
  };

  useEffect(() => {
    if (searchText && searchText.length > 2) {
      searchFilter();
    } else if ((searchText && searchText.length < 2) || searchText == "") {
      getVehicleList();
    }
  }, [searchText]);

  const searchFilter = () => {
    setLoading(true);
    let req = {
      vrn_contains: searchText,
      assignedVrnList: null,
    };
    filterVehicle(req)
      .then((res) => {
        setVehicleList(res || []);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log("<------------ error in tag details ----------->");
      });
  };

  


  return selectLayout === "vehicleDetails" || window.location.pathname === "/Profile/MyVehicles/UpdateKYV"  ? 
  (
    <Outlet  context={{selectedVrnData:vehicleList.filter((item) => (item.fastagId == selectedTagId)), selectedVrn:selectedVrn}} />

  ) : (
    <View style={styles.mainContainer}>
      {searchText == "" && vehicleList.length === 0 ? null : (
        <View style={styles.secondRowStyle}>
          <Text style={styles.searchTextStyle}>{"Search"}</Text>
          <TextInput
            style={styles.searchTextInputStyle}
            placeholder={"Vehicle Reg No."}
            value={searchText}
            onChangeText={(t) => {
              setSearchText(t);
              // searchVehicle();
            }}
          />
          <TouchableOpacity style={styles.searchIconContainerStyle}>
            <Image
              source={require("../../assets/images/search_icon.png")}
              style={styles.searchIconStyle}
            />
          </TouchableOpacity>
        </View>
      )}

      <View style={styles.container}>
        {searchText == "" && vehicleList.length === 0 ? (
          <View
            style={[
              styles.cardContainer,
              { alignItems: "center", justifyContent: "center", marginTop: 30 },
            ]}
          >
            <Text style={styles.addTagText} >
              {"You have not added any tag."}
            </Text>
          </View>
        ) : (
          <View>
            <Text style={styles.myVehTextStyle}>MyVehicles</Text>
            <ScrollView showsHorizontalScrollIndicator={false} showsVerticalScrollIndicator={true} horizontal={true} style={[styles.scrollViewStyle]}>
              <FlatList
                extraData
                style={styles.flatListStyle}
                data={isEmpty(vehicleList) ? [] : vehicleList}
                scrollToIndex={0}
                showsVerticalScrollIndicator={true}
                keyExtractor = {(item, index) => index+"_"+item?.id?.toString() }
                key={(item, index) => item.id}
                renderItem={({ item }) => {
                  return (
                    <TouchableOpacity
                      style={[styles.viewStyle]}
                      onPress={() => {
                        setSelectedLayout("vehicleDetails");
                        setSelectedVrn(get(item, "vrn", ""));
                        setSelectedTagId(get(item, "fastagId", ""));
                        RootNavigation.navigate('Profile/MyVehicles/VehicleDetails',{selectedVrn:item})
                      }}
                    >
                      <Image
                        source={require("../../assets/images/car.png")}
                        style={{
                          width: 51.5,
                          height: 47.6,
                          resizeMode: "contain",
                          flex: 1,
                        }}
                      />
                      <View style={{ paddingLeft: 15, flex: 3 }}>
                        <View
                          style={{
                            flexDirection: "row",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <View style={[styles.vehicleViewStyle, { flex: 4 }]}>
                            <Text style={styles.vehicleNoStyle}>
                              {get(item, "vrn", "")}
                            </Text>
                            <Text
                              style={[styles.vehicleNoStyle, { opacity: 0.6 }]}
                            >
                              {get(item, "vehicleModel", "")}
                            </Text>
                            <View>
                            <View style={{flexDirection: "row",alignItems: "center", marginTop: 5,}} >
                                  {item.kyvCompliant && item.status !== "Activated" ?
                                    <Image source={ require("../../assets/images/hotlisted_icon.png")} style={{height:16,width:16,top:0}}/>:""}
                                  <Text style={[styles.lowBalanceText,{color: "#e9730d"}]}>
                                  {item.kyvCompliant ? (item.status == "Hotlisted by service provider" ? "Hotlisted" :item.status=="Activated"?"":item.status) : <Marquee delay	={1} speed={20} loop={5} >KYV Pending. Click here to complete your KYV.     </Marquee>}
                                  </Text>
                                </View>
                            </View>
                          </View>
                          <View
                            style={{
                              alignItems: "center",
                              justifyContent: "center",
                              flex: 4,
                            }}
                          >
                            <Text style={styles.tagBalanceStyle}>
                              {"\u20B9  "}
                              {get(item, "fastagBalance", "").toFixed(2)}
                            </Text>
                            <TouchableOpacity
                              style={ rechargeNotAllowed?.includes(item.status) ? styles.rechargeViewStyleDisable :styles.rechargeViewStyle}
                              onPress={() => {
                                if(!rechargeNotAllowed?.includes(item.status)){
                                  RootNavigation.navigate("Recharge",{
                                    poolAcnt: get(item, "vrn", ""),
                                  },);
                                  global.activeScreen = "Recharge"
                                }
                            }}
                            >
                              <Text style={rechargeNotAllowed?.includes(item.status) ? styles.rechargeTextStyleDisable  : styles.rechargeTextStyle}>
                                {"Recharge"}
                              </Text>
                            </TouchableOpacity>
                          </View>
                        </View>
                        <View
                          style={[styles.verticalLineStyle, { width: "60%" }]}
                        />
                      </View>
                    </TouchableOpacity>
                  );
                }}
                numColumns={isSmallDevice ? null : isTabView ? 2 : 3}
                
              />
            </ScrollView>
          </View>
        )}
        <QuickLinks
          navigation={props.navigation}
          activeScreen={"Pool Account Details"}
          setScreen={props.setScreen}
          setIsManual={props.setIsManual}
        />
        {loading && <Loader />}
      </View>
      
    </View>
  );
};


//make this component available to the app
export default MyVehicles;
